// import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n';
import router from './router'
import api from '@/service/api/index.js'
import enLocale from './locales/en.json'; // 英文语言资源文件
import zhLocale from './locales/zh.json'; // 中文语言资源文件
// import 'element-ui/lib/theme-chalk/index.css';
// import ElementUI from 'element-ui';
import MetaInfo from 'vue-meta-info';

const Vue = window.Vue
const ELEMENT = window.ELEMENT
const echarts = window.echarts
Vue.use(MetaInfo)
Vue.use(ELEMENT);
Vue.use(VueI18n);
Vue.use(VueLazyload, {
  perLoad:0.5,
  attempt:1,
  // 设置懒加载时的占位图
  loading: 'https://tsgw.oss-cn-shanghai.aliyuncs.com/static/loading.gif',
  // 设置图片加载失败时的占位图
  error: 'https://tsgw.oss-cn-shanghai.aliyuncs.com/static/loading-fail.jpeg'
});
import VueLazyload from 'vue-lazyload';

const messages = {
  en: enLocale,
  zh: zhLocale
};
const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  messages
});
Vue.config.productionTip = false

Vue.prototype.$api = api
Vue.prototype.$imgUrl = 'https://tsgw.oss-cn-shanghai.aliyuncs.com/static/'
new Vue({
  router,
  render: h => h(App),
  i18n
}).$mount('#app')
